import { icon, label } from "../../config";
import store from "../../store";
import { appendString } from "../../utils/common";

export const userRolesOwners = [
  { value: "4", label: "Manager" },
  { value: "5", label: "Collaborator" },
];

export const userRolesCollaborators = [
  { value: "5", label: "Collaborator" },
];

export function getProjectHeaders() {
  const state = store.getState();
  const { operationalTeamName } = state.auth.user;
  return [
    { label: appendString(operationalTeamName, label.NAME), code: "Project Name", css: "project-name" },
    { label: appendString(operationalTeamName, label.CODE), code: "Project Code", css: "" },
    { label: "Workspace", code: "Workspace", css: "" },
    { label: "Default Workflow", code: "Default Workflow", css: "" },
    { label: "Members", code: "Members", css: "" },
    { label: "Tasks", code: "Tasks", css: "" },
    { label: "Last Activity", code: "Last Activity", css: "" },
    { label: "Workflows", code: "Workflows", css: "" },
    { label: "Emails", code: "Emails", css: "" },
    { label: "Business Unit", code: "Business Unit", css: "" },
    { label: "Cost Center", code: "Cost Center", css: "" },
    { label: "Forms", code: "Forms", css: "" },
    { label: "Automation", code: "Automation", css: "" },
  ];
}

export const projectStatus = [
  { value: "1", label: "Inactive" },
  { value: "2", label: "Active" },
  { value: "", label: "All" },
];

export const Email = "sample@sample.com";

export const initialSort = [
  {
    field: "ProjectName",

  },
];

export const initialSortAdmin = [
  {
    field: "logTime",
    dir: "desc",
  },
];

export const projectMainIcons = [
  { label: label.OVERVIEW, icon: icon.CHART_LINE, text: label.SETTINGS },
  { label: label.VIEW, icon: icon.FILTER_ICON, text: label.SETTINGS },
  { label: label.WORKFLOW, icon: icon.WORKFLOW_LUCID, text: label.SETTINGS },
 { label: label.LIBRARY, icon: icon.APP_LIBRARY },
 { label: label.STREAM, icon: icon.STREAM_ICON, text: label.STREAM },
];

export const projectMenuIcons = [
 { label: label.CANVAS, icon: icon.CANVAS_APP, text: label.TEAM_CONNECT },
];

/** Main + menu icons in one row; `iconGroup` selects click handling in ProjectCard */
export const projectCardIcons = [
  ...projectMainIcons.map((item) => ({ ...item, iconGroup: "main" })),
  ...projectMenuIcons.map((item) => ({ ...item, iconGroup: "menu" })),
];

export const teamLabels = {
  CONFIRMATION_HEADING_FOR_OWNER: "Are you sure you want to remove the user?",
  CONFIRMATION_MSG: "All the tasks/responsibilities upon removal will be assigned to ",
  CONFIRMATION_HEADING_FOR_USER: "Are you sure you want to leave the ",
  REMOVED_USER_BY_TEAM_OWNER_SUCCESS: " has successfully been removed from the ",
  REMOVED_FROM_TEAM_BY_ITSELF_SUCCESS: "You have successfully been removed from the ",
};
